import type { ZrmClickstreamUser, ZrmUserInfo } from './types';
import type { ClickstreamPayload } from '../types';
import { useEffect } from 'react';
import { getZrmUserInfo } from './getZrmUserInfo';

// https://dataportal.zillowgroup.net/event-registry/7227
function getZrmPageViewEvent(user?: ZrmClickstreamUser | null) {
  return {
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '7227',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_web_app',
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'zrm_web_app',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm'],
    },
    ...getZrmUserInfo(user),
  };
}

// This will track ZRM page view events for each client-side routed page, including the first pageload
export function useZrmPageViewEvents(
  trackEvent: ((event: ClickstreamPayload<ZrmUserInfo>) => void) | ((event: ClickstreamPayload) => void),
  pathname: string,
  user?: ZrmClickstreamUser | null,
) {
  useEffect(() => {
    trackEvent(getZrmPageViewEvent(user));
    // do not rely on consumers to memoize deps; only fire when pathname changes to prevent data corruption
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
}
